
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
  @Component
export default class Table extends Vue {
    @Prop() tableData: any

    mounted() {
    }
}
